import { Component, Input } from "@angular/core";

@Component({
  selector: "app-featured-success-story",
  templateUrl: "./featured-success-story.component.html",
  styleUrls: ["./featured-success-story.component.sass"],
})
export class FeaturedSuccessStoryComponent {
  @Input() routerLink: string;
  @Input() imageSrc: string;
  @Input() imageAlt: string;
  @Input() title: string;
}
